import {RoomBaseApiService} from "./room.baseapi.service";
import { ErrorWrapper, ResponseWrapper } from '@/core/service/util'

export class TestbankService extends RoomBaseApiService {
    async getTestbankList(params) {
        try {
            const response = await this.request().get(`/api/v3/testBank/banks`, { params: params });
            return new ResponseWrapper(response, response.data);
        } catch (error) {
            throw new ErrorWrapper(error);
        }
    }

    async createTestbank(params) {
        try {
            const response = await this.request().post(`/api/v3/testBank/banks/create`, params);
            return new ResponseWrapper(response, response.data.data);
        } catch (error) {
            throw new ErrorWrapper(error);
        }
    }

    async deleteTestbank(params) {
        try {
            const response = await this.request().delete(`/api/v3/testBank/${params.bankId}`);
            return new ResponseWrapper(response, response.data.data);
        } catch (error) {
            throw new ErrorWrapper(error);
        }
    }

    async getTestbankExamList(params) {
        try {
            const response = await this.request().get(`/api/v3/testBank/banks/${params.bankId}/exams?page=${params.page}&size=${params.size}&searchText=${params.searchText}`);
            return new ResponseWrapper(response, response.data);
        } catch (error) {
            throw new ErrorWrapper(error);
        }
    }

    async createTestbankExam(params) {
        try {
            const response = await this.request().post(`/api/v3/testBank/banks/${params.bankId}/exams/create`, { roomId: this.getRoomId(), ...params });
            return new ResponseWrapper(response, response.data.data);
        } catch (error) {
            throw new ErrorWrapper(error);
        }
    }

    async getTestbankExam(params) {
        try {
            const response = await this.request().get(`/api/v3/testBank/banks/${params.bankId}/exams/${params.bankExamId}`);
            return new ResponseWrapper(response, response.data.data);
        } catch (error) {
            throw new ErrorWrapper(error);
        }
    }

    async deleteTestbankExam(params) {
        try {
            const response = await this.request().delete(`/api/v3/testBank/banks/${params.bankId}/exams/${params.bankExamId}`);
            return new ResponseWrapper(response, response.data);
        } catch (error) {
            throw new ErrorWrapper(error);
        }
    }

    async editTestbankExam(params) {
        try {
            const response = await this.request().put(`/api/v3/testBank/banks/${params.bankId}/exams/${params.bankExamId}`, params);
            return new ResponseWrapper(response, response.data);
        } catch (error) {
            throw new ErrorWrapper(error);
        }
    }

    async getTestbankExamHistoryList(params) {
        try {
            const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/exams?page=${params.page}&size=${params.size}&examType=${params.examType}&examTitle=${params.examTitle}&inThisRoom=${params.inThisRoom}`);
            return new ResponseWrapper(response, response.data);
        } catch (error) {
            throw new ErrorWrapper(error);
        }
    }

    async getTestbankExamHistory(params) {
        try {
            const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/exams/${params.roomExamId}/exam`);
            return new ResponseWrapper(response, response.data.data);
        } catch (error) {
            throw new ErrorWrapper(error);
        }
    }
}

export const roomTestbankService = new TestbankService()